// Bubble text content for Mission 3 with highlights, keyboard layout conditionals, and fellow emotion.
// Bubble size is automatic based on text length.
// Optional per-page bubble layout overrides:
// - bubbleLeftPercent / bubbleBottomPercent
// - bubbleMinWidthPercent / bubbleMaxWidthPercent
// Optional per-page fellow emotion:
// - fellowEmotion: 'hq-happy' | 'hq-impressed' | 'hq-neutral' | 'hq-speaking'
// Each entry: { text: string, highlights: Array<{text?: string, conditional?: object}> }

const DEFAULT_LAYOUT_LABELS = {
 KeyZ: "Z",
 Slash: "/",
 KeyS: "S",
 KeyD: "D",
 KeyF: "F",
 KeyK: "K",
 KeyL: "L",
 Semicolon: ";",
};

export const MISSION_THREE_BUBBLE_TEXT = [
 // 1
 {
  text: `A new adventure awaits in a busy city with oncoming traffic.\n\nYour goal: Collect as many points as you can. But be careful! Some packages may contain bombs planted by the mafia.`,
  audioSrc: "assets/audio/instructions 3.1.mp3",
  fellowEmotion: "hq-happy",
  highlights: [
   { text: "Some packages may contain bombs" },
  ],
 },
 // 2
 {
  text: `Our spies are on your side:\n\nThey have identified the mafia type of each car (see the right box).\nThis city does not have a brightness mafia.\nTheir keys are grayed out (see the footer above).`,
  audioSrc: "assets/audio/instructions 3.2.mp3",
  fellowEmotion: "hq-impressed",
  highlights: [
   { text: "see" },
   { text: "right box" },
   { text: "not have a brightness mafia" },
   { text: "footer" },
  ],
 },
 // 3
 {
  text: `Our spies also tagged the value of each package (see the right box).`,
  audioSrc: "assets/audio/instructions 3.3.mp3",
  fellowEmotion: "hq-neutral",
  highlights: [
   { text: "see" },
   { text: "right box" },
  ],
 },
 // 4
 {
  text: `Sometimes you'll see a mystery briefcase on the road.\nYou must decide:\n\n  • Chase the briefcase and leave the target car behind. To do this, choose Lane 1.\n  • Stay with the target car and crack its code, as before.`,
  audioSrc: "assets/audio/instructions 3.4.mp3",
  fellowEmotion: "hq-speaking",
  highlights: [
   { text: "mystery briefcase" },
   { text: "Chase the briefcase" },
   { text: "Stay with the target car" },
  ],
 },
 // 5
 {
  text: `Some mystery briefcases have bombs.\n\nIf you collect one, you earn no points.`,
  audioSrc: "assets/audio/instructions 3.5.mp3",
  fellowEmotion: "hq-impressed",
  highlights: [
   { text: "bombs" },
   { text: "no points" },
  ],
 },
 // 6
 {
  text: `Buses will signal the bomb risk:\n\n  • If you see a yellow school bus, bomb risk is low.\n  • If you see a red emergency bus, bomb risk is high.\n  • Only buses can hide bombs. No bus = no bomb.`,
  audioSrc: "assets/audio/instructions 3.6.mp3",
  fellowEmotion: "hq-neutral",
  highlights: [
   { text: "yellow school bus" },
   { text: "red emergency bus" },
   { text: "No bus = no bomb" },
  ],
 },
 // 7
 {
  text: `Some keyboard tips:\n\n  • Rest your fingers on the keys as shown above.\n  • To make a response, press keys down without lifting your fingers. Tap, don't hold keys down.\n  • You can adjust speed when approaching cars AND packages in your lane.\n  • To slow down: Tap (don't hold) the {{KeyZ}} key.\n  • To speed up: Tap (don't hold) the {{Slash}} key.`,
  audioSrc: "assets/audio/instructions 3.7.mp3",
  fellowEmotion: "hq-speaking",
  highlights: [
   { text: "fingers" },
   { text: "without lifting your fingers" },
   { text: "adjust speed" },
   { text: "approaching cars AND packages" },
   { text: "slow down" },
   { text: "speed up" },
   { conditional: { key: "KeyZ" } },
   { conditional: { key: "Slash" } },
  ],
 },
 // 8
 {
  text: `Stay sharp and balance the risks and benefits.\n\nYou can go back and review if you'd like. Once you continue, the mission will begin and these messages will disappear.\n\nTip: While in a lane, you can adjust speed by tapping {{Slash}} to go faster or {{KeyZ}} to slow down.`,
  audioSrc: "assets/audio/instructions 3.8.mp3",
  fellowEmotion: "hq-happy",
  highlights: [
   { text: "balance the risks and benefits" },
   { text: "adjust speed" },
   { conditional: { key: "KeyZ" } },
   { conditional: { key: "Slash" } },
  ],
 },
];

function buildLabelsFromLayoutConfig(layoutConfig) {
 return {
  ...DEFAULT_LAYOUT_LABELS,
  KeyZ: layoutConfig?.backwardSlowDownKey ?? DEFAULT_LAYOUT_LABELS.KeyZ,
  Slash: layoutConfig?.forwardSpeedUpKey ?? DEFAULT_LAYOUT_LABELS.Slash,
  KeyS: layoutConfig?.KeyS ?? DEFAULT_LAYOUT_LABELS.KeyS,
  KeyD: layoutConfig?.KeyD ?? DEFAULT_LAYOUT_LABELS.KeyD,
  KeyF: layoutConfig?.KeyF ?? DEFAULT_LAYOUT_LABELS.KeyF,
  KeyK: layoutConfig?.KeyK ?? DEFAULT_LAYOUT_LABELS.KeyK,
  KeyL: layoutConfig?.KeyL ?? DEFAULT_LAYOUT_LABELS.KeyL,
  Semicolon: layoutConfig?.Semicolon ?? DEFAULT_LAYOUT_LABELS.Semicolon,
 };
}

export function getKeyLabel(key, layoutConfig) {
 const labels = buildLabelsFromLayoutConfig(layoutConfig);
 return labels[key] || key;
}
